"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("@turajs/util");
function convertShortStringToContractData(shortString) {
    const MaxChars = 8;
    if (shortString.length > MaxChars) {
        throw new Error(`At maximum ${MaxChars} bytes/characters are supported`);
    }
    return util_1.convertHexStringToDecString(util_1.convertHexEndianess(util_1.convertStringToHexString(shortString)));
}
exports.convertShortStringToContractData = convertShortStringToContractData;
//# sourceMappingURL=convertShortStringToContractData.js.map